import cls from "classnames";
import { InputHTMLAttributes, ReactNode, forwardRef } from "react";

import styles from "./index.module.scss";

type Props = {
  /** Rendered before the input (search icon, etc.). */
  leading?: ReactNode;
  /** Rendered after the input (clear button, etc.). */
  trailing?: ReactNode;
  className?: string;
} & InputHTMLAttributes<HTMLInputElement>;

/**
 * Text-input pill (the Library-search treatment): white on
 * --Stroke-Interactive, fully rounded, focus ring on the wrapper.
 *
 * The ref lands on the inner <input>, so integration layers that need a
 * handle on the real control (react-autosuggest's renderInputComponent
 * contract, imperative focus()) can treat Field as the input it wraps.
 */
const Field = forwardRef<HTMLInputElement, Props>(function Field(
  { leading, trailing, className, ...rest },
  ref
) {
  return (
    <label className={cls(styles.field, "talaera-field", className)}>
      {leading}
      <input ref={ref} {...rest} />
      {trailing}
    </label>
  );
});

export default Field;
